import React, { useState } from 'react';
import { FaPhoneAlt, FaTimes } from 'react-icons/fa';
import { motion, AnimatePresence } from 'framer-motion';

const CallButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const numbers = [
    { number: '9726344477', label: 'Primary Contact' },
    { number: '9726766777', label: 'Secondary Contact' },
  ];

  return (
    <div className="fixed bottom-32 right-5 z-50">
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, scale: 0.8, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.8, y: 20 }}
            className="absolute bottom-16 right-0 mb-2 w-64 bg-white rounded-2xl shadow-2xl overflow-hidden"
          >
            <div className="bg-blue-500 text-white p-4 flex justify-between items-center">
              <div className="flex items-center space-x-2">
                <FaPhoneAlt size={20} />
                <h4 className="font-bold">Call Our Experts</h4>
              </div>
              <button onClick={() => setIsOpen(false)} className="hover:bg-blue-600 rounded-full p-1">
                <FaTimes />
              </button>
            </div>
            <div className="p-4">
              <p className="text-gray-600 text-sm mb-3">Choose a number to call:</p>
              {numbers.map((item, idx) => (
                <a
                  key={idx}
                  href={`tel:${item.number}`}
                  className="flex justify-between items-center p-3 hover:bg-gray-100 rounded-lg transition-colors mb-2"
                >
                  <div>
                    <div className="font-semibold text-gray-800">{item.number}</div>
                    <div className="text-xs text-gray-500">{item.label}</div>
                  </div>
                  <FaPhoneAlt className="text-blue-500" />
                </a>
              ))}
              <p className="text-xs text-gray-500 text-center mt-3">
                Available: Mon-Sat, 10 AM - 7 PM
              </p>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <motion.button
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        onClick={() => setIsOpen(!isOpen)}
        className="bg-blue-500 text-white p-4 rounded-full shadow-lg hover:bg-blue-600 transition-all duration-300 animate-pulse"
      >
        <FaPhoneAlt size={30} />
      </motion.button>
    </div>
  );
};

export default CallButton;